export default $client => ({
    get() {
        return $client.get('stock-exchanges');
    },
});
